import { FC } from 'react'
import PageLayout from '../../../components/page-layout/page-layout'
import MaterialOrderRequests from './components/material-order-requests/material-order-requests'

const MaterialOrderRequestsPage: FC = () => {
    return (
        <PageLayout title={'Заказ материала'}>
            <MaterialOrderRequests />
        </PageLayout>
    )
}

export default MaterialOrderRequestsPage
